import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesMetadata extends BaseAction {
    constructor(onError) {
        const id = '9380e5a4-d09d-4b35-8bdd-5dd414466720'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = false

        this.onError = onError
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'message']
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-metadata.js